import { initFadeIn } from './vendor/fade-in.js';

async function appendLoadedContentIntoReceptacle(
	url: string,
	receptacle: HTMLElement,
	receptacle_selector: string
): Promise<boolean> {
	const response = await fetch( url );
	if ( !response.ok ) {
		return false;
	}

	const fragment = ( new DOMParser() ).parseFromString(
		await response.text(),
		'text/html'
	);
	const content_to_append = fragment.querySelector( receptacle_selector );
	if ( null === content_to_append ) {
		return false;
	}
	const append_fragment = new DocumentFragment();
	append_fragment.append( ...content_to_append.childNodes );
	receptacle.append( append_fragment );

	return true;
}

( () => {

	// Pagination

	const pagination = document.querySelector( '[data-pagination]' );
	if ( !pagination || !( pagination instanceof HTMLElement ) ) {
		return;
	}

	const pagination_reveal_prev = pagination.querySelector( '[data-reveal-prev]' );
	const pagination_reveal_next = pagination.querySelector( '[data-reveal-next]' );

	if ( pagination_reveal_prev ) {
		pagination_reveal_prev.addEventListener( 'click', () => {
			pagination.classList.add( 'pagination--reveal-prev' );
		} );
	}
	if ( pagination_reveal_next ) {
		pagination_reveal_next.addEventListener( 'click', () => {
			pagination.classList.add( 'pagination--reveal-next' );
		} );
	}

	// Load more

	const load_more_receptacle_selector = pagination.dataset.paginationLoadMoreReceptacle as string;
	if ( '' === load_more_receptacle_selector ) {
		return;
	}
	const load_more_receptacle = document.querySelector(
		load_more_receptacle_selector
	) as HTMLElement;
	if ( null === load_more_receptacle ) {
		console.error( // eslint-disable-line no-console
			`Pagination load more receptacle ${load_more_receptacle_selector} not found.`
		);
		return;
	}

	const load_more_links = Array.from(
		pagination.querySelectorAll( '[data-page-link]' ) as NodeListOf<HTMLAnchorElement>
	).map( anchor => anchor.href );
	if ( load_more_links.length === 0 ) {
		return;
	}

	const load_more_button = pagination.querySelector( '.pagination__load-more-button' );
	if ( null === load_more_button ) {
		return;
	}
	let load_more_index = 0;
	pagination.classList.add( 'pagination--load-more-enabled' );
	load_more_receptacle.setAttribute( 'aria-live', 'polite' );

	load_more_button.addEventListener( 'click', async () => {
		const success = await appendLoadedContentIntoReceptacle(
			load_more_links[load_more_index],
			load_more_receptacle,
			load_more_receptacle_selector
		);
		if ( !success ) {
			return;
		}
		initFadeIn();
		window.history.replaceState( null, '', load_more_links[load_more_index] );
		load_more_index++;
		if ( load_more_index === load_more_links.length ) {
			pagination.classList.remove( 'pagination--load-more-enabled' );
		}
	} );

} )();
